// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store/index.js'

Vue.config.productionTip = false

import Mint from 'mint-ui'
Vue.use(Mint)
import 'mint-ui/lib/style.css'
import '../static/css/Pubulic.css'
import 'video.js/dist/video-js.css'
import scroll from 'vue-seamless-scroll'
import LuckDraw from 'vue-luck-draw';
import echarts from 'echarts'
import GetApi from '../static/js/Gethttp'

import { Toast,Indicator,MessageBox,Actionsheet} from 'mint-ui';
Vue.prototype.$echarts = echarts
Vue.prototype.$Get=GetApi.gethttp
Vue.prototype.$axios=axios
Vue.prototype.$Toast=Toast
Vue.prototype.$Indicator=Indicator
Vue.prototype.$MessageBox=MessageBox
Vue.prototype.$Pub_url = 'http://www.hbrlzy.org.cn/'
import { Picker } from 'vant';
Vue.use(Picker);
Vue.use(scroll)
Vue.use(LuckDraw)
Vue.component(Actionsheet.name, Actionsheet);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
	store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js